
/**
 * JavaScript React Framework
 */
import React from 'react';

/**
 * React-Bootstrap
 */ 
import { NavDropdown, MenuItem } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import NavBarMenuItem from '../../common/navbar/NavBarMenuItem.js';

/**
 * Note: Your components tell React what you want to render
 */
class AppNavBarAboutMe extends React.Component {
	render() {
		return (
      <NavDropdown eventKey={this.props.eventKey} title="LinkedIn Articles" id="nav-dropdown">
        <NavBarMenuItem eventKey={this.props.eventKey + ".1"} glyph="cloud" href="https://www.linkedin.com/pulse/reinterpretation-university-corporate-shared-services-tracy-brown"> Shared Services</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".2"} glyph="grain" href="https://www.linkedin.com/pulse/space-operations-astronaut-health-informatics-tracy-brown"> Space Operations</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".3"} glyph="modal-window" href="https://www.linkedin.com/pulse/topics-computer-science-patterns-decorators-geometries-tracy-brown"> Engineering Simulators</NavBarMenuItem>
        <MenuItem divider />
        <NavBarMenuItem eventKey={this.props.eventKey + ".4"} glyph="heart-empty" href="https://www.linkedin.com/pulse/operational-health-informatics-tracy-brown"> Health Informatics</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".5"} glyph="transfer" href="https://www.linkedin.com/pulse/brief-look-medical-record-de-identification-policy-tracy-brown"> Hospital De-Identification</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".6"} glyph="tasks" href="https://www.linkedin.com/pulse/short-story-pragmatic-artificial-intelligence-tracy-brown"> Artificial Intelligence</NavBarMenuItem>
      </NavDropdown>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default AppNavBarAboutMe;



// WEBPACK FOOTER //
// ./src/cba/appspec/header/Nav_AppNavBar_LinkedIn.js